import { render, staticRenderFns } from "./AnimatedQuotesList.vue?vue&type=template&id=0579d260&scoped=true&lang=pug"
import script from "./AnimatedQuotesList.vue?vue&type=script&lang=js"
export * from "./AnimatedQuotesList.vue?vue&type=script&lang=js"
import style0 from "./AnimatedQuotesList.vue?vue&type=style&index=0&id=0579d260&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0579d260",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {Icon: require('/home/docker/code/frontend/components/Icon.vue').default})
